var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.539917 9.89545L0.539917 8.06434L2.48022 8.06434L2.48022 6.08476L4.32101 6.08476L4.32101 4.20417L2.48022 4.20417L2.48022 2.22459L0.539917 2.22459L0.539917 0.492462L6.0623 0.492462L6.0623 2.42255L7.95285 2.42255L7.95285 4.20417L9.9429 4.20417L9.9429 6.08476L7.95285 6.08476L7.95285 7.86638L6.0623 7.86638L6.0623 9.89545L0.539917 9.89545Z",
    fill: "#FFC107"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeArrow);
export default __webpack_public_path__ + "static/media/ge-arrow.3250f25e49426702f8db200923071270.svg";
export { ForwardRef as ReactComponent };